import { render, staticRenderFns } from "./LogradiusDatatable.vue?vue&type=template&id=5d0ab3d7&scoped=true&"
import script from "./LogradiusDatatable.vue?vue&type=script&lang=js&"
export * from "./LogradiusDatatable.vue?vue&type=script&lang=js&"
import style0 from "./LogradiusDatatable.vue?vue&type=style&index=0&id=5d0ab3d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ab3d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
